import EventEmitter from "eventemitter3";
import StoreProps from "../types/Store";
import Store from "./Store";
import Translation from "./Translation";

class StoreBlock {
    EEE: EventEmitter;
    currentStore: StoreProps | null | undefined;
    storeBlocks: NodeListOf<Element>;

    constructor() {
        this.EEE = new EventEmitter();
        this.currentStore = undefined;
        this.storeBlocks = document.querySelectorAll("#store-block");

        this.init();
    }

    // init when store blocks exist
    init() {
        if (this.storeBlocks.length > 0) {
            this.addListeners();
            this.updateStore();
        }
    }

    // Add the store change listeners
    addListeners() {
        this.EEE.on("STORE_CHANGED", (id) => this.updateStore(id));
    }

    // Update the class state
    updateStore(id?: number) {
        if (id && this.currentStore && this.currentStore.id !== id)
            Store.setStore(id);
        this.currentStore = Store.getCurrentStore();
        this.updateBlock();
    }

    findStoreHelpText() {
        return `${this.currentStore?.title ?? Translation.getText("Store","FindStore")} i Google Maps, öppnas i ny flik`;
    }

    // Update the frontend component
    updateBlock() {
        this.storeBlocks.forEach((storeBlock) => {
            if (this.currentStore) {
                const name = storeBlock.querySelector(
                    ".store-block__store-name",
                ) as HTMLElement;
                const openingHours = storeBlock.querySelector(
                    ".store-block__opening-hours",
                ) as HTMLElement;
                const phone = storeBlock.querySelector(
                    ".store-block__phone",
                ) as HTMLElement;
                const addresses = storeBlock.querySelector(
                    ".store-block__addresses",
                ) as HTMLElement;
                const links = storeBlock.querySelector(
                    ".store-block__links",
                ) as HTMLElement;
                const image = storeBlock.querySelector(
                    ".store-block__image-item",
                ) as HTMLElement;

                if (name) name.textContent = this.currentStore.title || "";

                if (openingHours)
                    openingHours.textContent =
                        this.currentStore.opening_hours_large || "";

                if (addresses) {
                    addresses.replaceChildren();
                    [
                        this.currentStore.address1,
                        this.currentStore.address2,
                        this.currentStore.address3,
                        this.currentStore.address4,
                    ]
                        .filter(Boolean)
                        .forEach((address) => {
                            const paragraph = document.createElement("p");
                            paragraph.className = "store-block__address";
                            paragraph.textContent = address;
                            addresses.append(paragraph);
                        });
                }

                if (phone) {
                    phone.replaceChildren();
                    if (this.currentStore.phone && this.currentStore.phone_url) {
                        const wrapper = document.createElement("div");
                        const label = document.createElement("span");
                        const link = document.createElement("a");
                        label.textContent = "Tel. ";
                        link.href = this.currentStore.phone_url;
                        link.textContent = this.currentStore.phone;
                        wrapper.append(label, link);
                        phone.append(wrapper);
                    }
                }

                if (links) {
                    links.replaceChildren();
                    if (this.currentStore.link) {
                        const storeLink = document.createElement("a");
                        storeLink.href = this.currentStore.link;
                        storeLink.className = "button";
                        storeLink.textContent = Translation.getText(
                            "Store",
                            "MoreOfStore",
                        );
                        links.append(storeLink);
                    }
                    if (this.currentStore.position) {
                        const positionLink = document.createElement("a");
                        const icon = document.createElement("i");
                        const helpText = this.findStoreHelpText();
                        positionLink.href = this.currentStore.position.address;
                        positionLink.target = "_blank";
                        positionLink.rel = "noopener";
                        positionLink.className =
                            "button store-block__external-link";
                        positionLink.ariaLabel = helpText;
                        positionLink.title = helpText;
                        positionLink.textContent = Translation.getText(
                            "Store",
                            "FindStore",
                        );
                        icon.className =
                            "fa-solid fa-arrow-up-right-from-square";
                        positionLink.append(icon);
                        links.append(positionLink);
                    }
                }

                if (image)
                    if (this.currentStore.map_image) {
                        image.classList.remove("is-hidden");
                        image.style.backgroundImage = `url("${this.currentStore.map_image}?preset=large")`;
                    } else {
                        image.style.backgroundImage = "";
                        image.classList.add("is-hidden");
                    }
            }
        });
    }
}

export default StoreBlock;
